import { api } from './NetworkUtility';
import { logError } from './ErrorService';

let getCompanyDetailsAbortController = new AbortController();
let getCompanyPermissionsAbortController = new AbortController();

export const getCompanies = (callbackHandler) => {
    const url = `/companies`;

    api.get(url)
        .then(response => {
            if (response?.data?.companies && response?.data?.companies.length) {
                return convertCompanyListToOptions(response.data.companies);
            } else {
                return Promise.reject("No company data");
            }
        })
        .then(data => {
            callbackHandler(data)
        })
        .catch(function (error) {
            // Abort errors can be ignored
            if (error?.code !== 'ERR_CANCELED') {
                //navigate hook does not work here, using window.location to redirect
                if (error?.response?.status === 401 || error?.response?.status === 403) {
                    //unauthorized user - log unauth attempt and redirect
                    logError("Unauthorized user attempt", () => {
                        window.location = "/unauthorizedUser?c";
                    });
                } else {
                    //global error
                    window.location = "/error?c";
                }
            }
        });
}

const convertCompanyListToOptions = (companies) => {
    let companyList = [];
    companies.forEach(company => {
        companyList.push({
            label: `${company.company_name} - ${company.company_number}`,
            value: company.company_number,
            companyName: company.company_name,
            companyNumber: company.company_number,
        })
    });

    return companyList;
}

export const getCompanyDetails = (company, callbackHandler) => {
    if (company == null || typeof company === 'undefined'
        || company.companyNumber == null || typeof company.companyNumber === 'undefined') {
        return;
    }

    const url = `/companies/${company.companyNumber}`;

    // Abort any previous calls before retrieving new company details
    getCompanyDetailsAbortController.abort();
    getCompanyDetailsAbortController = new AbortController();

    api.get(url, {
        signal: getCompanyDetailsAbortController.signal
    })
        .then(response => {
            callbackHandler(response.data.company);
        })
        .catch(error => {
            // Abort errors can be ignored 
            if (error?.code !== 'ERR_CANCELED') {
                //navigate hook does not work here, using window.location to redirect
                if (error?.response?.status === 401 || error?.response?.status === 403) {
                    //unauthorized user - log unauth attempt and redirect
                    logError("Unauthorized user attempt", () => {
                        window.location = "/unauthorizedUser?cd";
                    });
                } else {
                    //global error
                    window.location = "/error?cd";
                }
            }
        })
}

export const getPermissionsForCompany = (companyNumber, callbackHandler) => {
    if (companyNumber == null || typeof companyNumber === 'undefined') {
        return;
    }
    
    const url = `/companies/${companyNumber}/permissions`;

    // Abort any previous calls before retrieving new company permissions
    getCompanyPermissionsAbortController.abort();
    getCompanyPermissionsAbortController = new AbortController();

    api.get(url)
        .then(response => {
            callbackHandler(response.data.permissions)
        })
        .catch(function (error) {
            // Abort errors can be ignored 
            if (error?.code !== 'ERR_CANCELED') {
                //navigate hook does not work here, using window.location to redirect
                if (error?.response?.status === 401 || error?.response?.status === 403) {
                    //unauthorized user - log unauth attempt and redirect
                    logError("Unauthorized user attempt", () => {
                        window.location = "/unauthorizedUser?cp";
                    });
                } else {
                    //global error
                    window.location = "/error?cp";
                }
            }
        });
}

export const getCompanyRoles = (companyNumber, callbackHandler) => {
    const url = `/companies/${companyNumber}/getCompanyRoles`;

    api.get(url)
        .then(response => {
            if (response?.data?.companyRoles && response?.data?.companyRoles.length) {
                return response.data.companyRoles;
            } else {
                return Promise.reject("No company role data");
            }
        })
        .then(data => {
            callbackHandler(data);
        })
        .catch(function (error) {
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?cr";
                });
            } else {
                //global error
                window.location = "/error?cr";
            }
        })
}

export const saveCompanyRole = async (role, companyNumber, callbackHandler, callbackHandlerError) => {
    const request = {
        "companyRoleUuid": role.roleUuid,
        "roleName": role.roleName,
        "description": role.description,
        "permissions": role.permissions
    }

    const url = `/companies/${companyNumber}/saveCompanyRole`;

    // errors will be handled by component 
    return api.post(url, request)
        .then(response => {
            callbackHandler(response);
        })
        .catch(error => {
            callbackHandlerError(error.response);
        });
}